<script>
export default {
	name: 'Anchor',
	props: {
		name: {
			type: String,
			required: true,
		},
		register: {
			type: Boolean,
			default: true,
		},
		group: {
			type: Boolean,
			default: false,
		},
		meta: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			id: false,
			updating: false,
			registered: false,
		};
	},
	computed: {
		anchor() {
			return {
				id: this.id,
				name: this.name,
				register: this.register,
				element: this.$slots.default[0].elm,
				group: this.group,
				meta: this.meta,
			};
		},
	},
	render() {
		return this.$slots.default;
	},
	mounted() {
		if (this.register) {
			this.$nextTick(() => {
				const registered = this.$anchors.register(this.anchor);
				this.id = this.group ? registered[registered.length - 1].id : registered.id;
				this.registered = true;
			});
		}
	},
	beforeDestroy() {
		if (this.registered) {
			this.$nextTick(() => this.$anchors.unregister({ name: this.name, id: this.id }));
		}
	},
	updated() {
		this.$nextTick(() => {
			this.id = this.$anchors.update(this.anchor);
			this.registered = this.id !== "false";
		});
	},
};
</script>



// WEBPACK FOOTER //
// src/plugins/vue-anchors-plugin/Anchor.vue